function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
var _STORAGE_KEY = _classPrivateFieldLooseKey("STORAGE_KEY");
var _MAX_PRODUCTS = _classPrivateFieldLooseKey("MAX_PRODUCTS");
/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();
    viewedProducts = viewedProducts.filter((/** @type {string} */id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, _classPrivateFieldLooseBase(this, _MAX_PRODUCTS)[_MAX_PRODUCTS]);
    localStorage.setItem(_classPrivateFieldLooseBase(this, _STORAGE_KEY)[_STORAGE_KEY], JSON.stringify(viewedProducts));
  }
  static clearProducts() {
    localStorage.removeItem(_classPrivateFieldLooseBase(this, _STORAGE_KEY)[_STORAGE_KEY]);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(_classPrivateFieldLooseBase(this, _STORAGE_KEY)[_STORAGE_KEY]) || '[]');
  }
}
/** @static @constant {string} The key used to store the viewed products in session storage */
Object.defineProperty(RecentlyViewed, _STORAGE_KEY, {
  writable: true,
  value: 'viewedProducts'
});
/** @static @constant {number} The maximum number of products to store */
Object.defineProperty(RecentlyViewed, _MAX_PRODUCTS, {
  writable: true,
  value: 4
});
